export const onloadCallback = () => {
    window.googletag = window.googletag || {cmd: []}
    window.googletag.cmd.push(function () {
        window.googletag.pubads().enableSingleRequest()
    })
}

export const init = () => {
    let scriptTag = document.createElement('script')
    scriptTag.setAttribute('src', 'https://securepubads.g.doubleclick.net/tag/js/gpt.js')
    scriptTag.setAttribute('defer', 'defer')
    scriptTag.setAttribute('onload', 'window.ads.onloadGoogleAds()')
    document.body.appendChild(scriptTag)
}